'use client';

import { c as _c } from "react/compiler-runtime";
import './MopinionSurvey.css';
import { useEffect, useState } from 'react';
import { LoadMopinion, MopinionSRV } from './LoadMopinion';
import { createExpirableLocalStorage } from '@/globals/webStorage/expirableLocalStorage';
import { getMSFromDays } from '@/globals/helpers/microseconds.helpers';
import * as v from 'valibot';
import { pushMopinionEvent } from '@/globals/analytics/events/pushMopinionEvent';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
const getSessionSurveyShownCount = () => {
  try {
    const count = window.sessionStorage.getItem('surveyShownCount');
    if (count == null) return 0;
    return parseInt(count, 10);
  } catch (_error) {
    return 0;
  }
};
const setSessionSurveyShownCount = (count: number) => {
  try {
    window.sessionStorage.setItem('surveyShownCount', count.toString());
  } catch (_error) {
    // NOOP
  }
};
const surveyDoneExpirableLocalStorage = createExpirableLocalStorage({
  key: 'surveyPopupDone',
  maxAgeInMS: getMSFromDays(31),
  schema: v.boolean()
});
type MopinionData = {
  formName: string;
  url?: string;
};
export const MopinionSurvey = t0 => {
  const $ = _c(14);
  const {
    surveyID,
    delayInSeconds,
    reminderDelayInSeconds,
    url
  } = t0;
  const [surveyPoppedUp, setSurveyPoppedUp] = useState(false);
  const [mopinionSRV, setMopinionSRV] = useState(null);
  let t1;
  let t2;
  if ($[0] !== delayInSeconds || $[1] !== reminderDelayInSeconds) {
    t1 = () => {
      if (surveyDoneExpirableLocalStorage.get()) {
        return;
      }
      const delay = getSessionSurveyShownCount() === 0 ? delayInSeconds : reminderDelayInSeconds;
      const timer = setTimeout(() => {
        if (surveyDoneExpirableLocalStorage.get()) {
          return;
        }
        setSurveyPoppedUp(true);
      }, delay * 1000);
      return () => {
        clearTimeout(timer);
      };
    };
    t2 = [delayInSeconds, reminderDelayInSeconds];
    $[0] = delayInSeconds;
    $[1] = reminderDelayInSeconds;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== mopinionSRV || $[5] !== surveyID || $[6] !== surveyPoppedUp) {
    t3 = () => {
      if (!surveyPoppedUp) {
        return;
      }
      if (mopinionSRV == null) {
        return;
      }
      if (surveyDoneExpirableLocalStorage.get()) {
        return;
      }
      mopinionSRV.openModal(true, surveyID);
      return () => {
        mopinionSRV.closeModal(surveyID);
      };
    };
    t4 = [mopinionSRV, surveyID, surveyPoppedUp];
    $[4] = mopinionSRV;
    $[5] = surveyID;
    $[6] = surveyPoppedUp;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[9] !== url) {
    t5 = () => {
      const abortController = new AbortController();
      document.addEventListener("mopinion_shown", event => {
        if (event.detail) {
          pushMopinionEvent({
            url,
            formName: event.detail.formName,
            action: "Show popup"
          });
        }
        setSessionSurveyShownCount(getSessionSurveyShownCount() + 1);
        if (getSessionSurveyShownCount() >= 2) {
          surveyDoneExpirableLocalStorage.set(true);
        }
      }, {
        signal: abortController.signal
      });
      document.addEventListener("mopinion_hidden", event_0 => {
        if (event_0.detail) {
          pushMopinionEvent({
            url,
            formName: event_0.detail.formName,
            action: "Close popup"
          });
        }
      }, {
        signal: abortController.signal
      });
      document.addEventListener("mopinion_feedback_sent", _temp, {
        signal: abortController.signal
      });
      document.addEventListener("mopinion_question_answered", _temp2, {
        signal: abortController.signal
      });
      document.addEventListener("mopinion_next", _temp3, {
        signal: abortController.signal
      });
      document.addEventListener("mopinion_redirect", event_1 => {
        if (event_1.detail) {
          pushMopinionEvent({
            url,
            formName: event_1.detail.formName,
            action: "Click to survey",
            externalLink: event_1.detail.url
          });
        }
        surveyDoneExpirableLocalStorage.set(true);
      }, {
        signal: abortController.signal
      });
      return () => {
        abortController.abort();
      };
    };
    t6 = [url];
    $[9] = url;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  if (!surveyPoppedUp) {
    return null;
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LoadMopinion setSRV={setMopinionSRV} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <>{t7}<div id="surveyContent" className={classes(unprintable)} /></>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
function _temp() {
  surveyDoneExpirableLocalStorage.set(true);
}
function _temp2() {
  surveyDoneExpirableLocalStorage.set(true);
}
function _temp3() {
  surveyDoneExpirableLocalStorage.set(true);
}